/**
 * @generated SignedSource<<46dac69883584262dcfa5d1d778fd765>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SettingsCategoryEditPageQuery$variables = {
  id: string;
};
export type SettingsCategoryEditPageQuery$data = {
  readonly category: {
    readonly name: string;
    readonly " $fragmentSpreads": FragmentRefs<"CategoryEditForm_category" | "EntitySidebar_entity">;
  } | null;
};
export type SettingsCategoryEditPageQuery = {
  response: SettingsCategoryEditPageQuery$data;
  variables: SettingsCategoryEditPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SettingsCategoryEditPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Category",
        "kind": "LinkedField",
        "name": "category",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CategoryEditForm_category"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "EntitySidebar_entity"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SettingsCategoryEditPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Category",
        "kind": "LinkedField",
        "name": "category",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "uuid",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "updatedAt",
                "storageKey": null
              }
            ],
            "type": "Entity",
            "abstractKey": "__isEntity"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "aac26d3ba593df3352e1f60554ef4ccd",
    "id": null,
    "metadata": {},
    "name": "SettingsCategoryEditPageQuery",
    "operationKind": "query",
    "text": "query SettingsCategoryEditPageQuery(\n  $id: ID!\n) {\n  category(id: $id) {\n    name\n    ...CategoryEditForm_category\n    ...EntitySidebar_entity\n    id\n  }\n}\n\nfragment CategoryEditForm_category on Category {\n  id\n  name\n}\n\nfragment EntitySidebar_entity on Entity {\n  __isEntity: __typename\n  uuid\n  createdAt\n  updatedAt\n}\n"
  }
};
})();

(node as any).hash = "4c94cee8e590aa57baa4fbdfd8a7d62b";

export default node;
